module.exports = __webpack_public_path__ + "static/media/first-time-check-in.4d765303.svg";